/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { func, object, string } from 'prop-types';
import { makeStyles } from '@material-ui/core';

import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import OfferGatewayBannerTall from './OfferGatewayBannerTall';
import noop from '../../../../../helpers/noop';
import { setOfferGatewayData } from '../../../../../../state/ducks/App/App-Actions';

const useStyles = makeStyles((theme) => ({
    defaultCSS: {
        width: '100%',
        maxWidth: '1920px',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(600)]: {
            display: 'block',
        },
    },
    withGridSystem: {
        margin: '0 auto',
        maxWidth: '1400px',
        width: '100%',
    },
    offerGatewayFlexContainer: {
        width: '100%',
        maxWidth: '1400px',
        margin: '0 auto',
    },
}));

// Sync with UniversalHomepageComponent.js to make similar banners styling.

const OfferGatewayBannerContainer = ({
    blockKey, blockObj, salesforceResponse, setShowSkeleton, skeleton_height, skeleton_width,
}) => {
    const classes = useStyles();
    const ffHasHomepageGridStructure = useSelector(getFeatureFlag('has-homepage-grid-structure'));

    const dispatch = useDispatch();

    useEffect(() => {
        if (!blockObj || !salesforceResponse?.content) {
            setShowSkeleton(false);
        }

        dispatch(setOfferGatewayData({
            salesforceResponse,
        }));
    }, [salesforceResponse]);

    const OfferGatewayBannerContainerStyle = ffHasHomepageGridStructure ? classes.withGridSystem : classes.defaultCSS;

    const blockData = salesforceResponse?.content ? salesforceResponse.content : blockObj;// blockObj is used for fallbackUI

    const renderBanner = () => {
        switch (blockKey) {
            case 'offer_gatway_banner_tall':
                return (
                    <OfferGatewayBannerTall
                        blockObj={blockData}
                        blockKey={blockKey}
                        salesforceResponse={salesforceResponse}
                        setShowSkeleton={setShowSkeleton}
                        bannerHeight={skeleton_height}
                        bannerWidth={skeleton_width}
                    />
                );

            default:
                return null;
        }
    };

    if (blockData) {
        return (
            <div className={OfferGatewayBannerContainerStyle} data-testid="homepage_offer_gateway_component">
                <div className={classes.offerGatewayFlexContainer}>
                    <style>{'[data-pagetype="homepage"]>div[data-component="universalHomepageComponent"]'}</style>
                    {renderBanner()}
                </div>
            </div>
        );
    }

    return null;
};

OfferGatewayBannerContainer.propTypes = {
    salesforceResponse: object,
    blockKey: string,
    setShowSkeleton: func,
    blockObj: object,
    skeleton_height: string,
    skeleton_width: string,
};

OfferGatewayBannerContainer.defaultProps = {
    salesforceResponse: {},
    blockKey: '',
    blockObj: {},
    setShowSkeleton: noop,
    skeleton_height: '',
    skeleton_width: '',
};

export default OfferGatewayBannerContainer;
